<template>
  <v-data-table
    :headers="headers"
    :items="displayEvents"
    :loading="loading"
    :rows-per-page-items="[30, 50, 100]"
    :pagination.sync="pagination"
    item-key="schedule_id"
    no-data-text="No events match these schedule filters.">
    <template
      slot="items"
      slot-scope="props">
      <td>{{ props.item.eventType }}</td>
      <td><div
        v-for="(wine, i) in props.item.wines"
        :key="i">{{ wine }}</div></td>
      <td><div
        v-for="(wine, i) in props.item.sub_wines"
        :key="i">{{ wine }}</div></td>
      <td>{{ props.item.storename }}</td>
      <td>{{ props.item.warehouse_id }}</td>
      <td class="schedule-shift">{{ props.item.schedule_date }}<br>{{ time(props.item.time_start) }} - {{ time(props.item.time_end) }}</td>
      <td>{{ props.item.city }}</td>
      <td>{{ props.item.state }}</td>
      <td>{{ storeLabel }}</td>
      <td>{{ props.item.work_order }}</td>
      <td>{{ props.item.supplier }}</td>
    </template>
  </v-data-table>
</template>

<script>
import { scheduleEventType, supplierName } from '../services/group.service'

export default {
  props: {
    events: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    storeLabel: { type: String, default: '' },
    state: { type: String, default: '' }
  },
  data: () => ({
    pagination: { rowsPerPage: 30, sortBy: 'schedule_date', descending: false }
  }),
  computed: {
    headers () {
      return [
        { text: 'Event Type', value: 'eventType' },
        { text: 'Product', value: 'wines' },
        { text: 'Substitutions', value: 'sub_wines' },
        { text: 'Store Name', value: 'storename' },
        { text: 'Store #', value: 'warehouse_id' },
        { text: `Shift (${this.state || 'local'} time)`, value: 'schedule_date' },
        { text: 'City', value: 'city' },
        { text: 'State', value: 'state' },
        { text: 'Retailer', sortable: false },
        { text: 'Work Order', value: 'work_order' },
        { text: 'Supplier', value: 'client_name' }
      ]
    },
    displayEvents () {
      return this.events.map(event => ({ ...event, eventType: scheduleEventType(event), supplier: supplierName(event.client_name) }))
    }
  },
  methods: {
    time (value) {
      if (!value) return 'Time unavailable'
      const [hours, minutes] = value.split(':')
      return `${Number(hours) % 12 || 12}:${minutes} ${Number(hours) < 12 ? 'AM' : 'PM'}`
    }
  }
}
</script>

<style scoped>
.schedule-shift {
  white-space: nowrap;
}
</style>
